import React from "react";
import Modal from "react-bootstrap/Modal";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";

class CustomLoader extends React.Component {
  render() {
    const { message } = this.props;

    return (
      <Modal show centered>
        <Modal.Body>
          <FormLoader source="Modal" loading="true" />
          <p className="text-center">{message}</p>
        </Modal.Body>
      </Modal>
    );
  }
}

export default CustomLoader;
